import "../instrument.js"
import * as Sentry from '@sentry/react';
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { ToastProvider } from './components/ToastProvider';
import './index.css'
import App from './App.tsx'

const container = document.getElementById('root');

// 2. Initialize the root with Sentry Error Handlers
const root = createRoot(container!, {
    // Captures errors thrown but not caught by any Error Boundary
    onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
        console.warn('Uncaught error', error, errorInfo.componentStack);
    }),
    // Captures errors that ARE caught by an Error Boundary
    onCaughtError: Sentry.reactErrorHandler(),
    // Captures errors React recovered from automatically
    onRecoverableError: Sentry.reactErrorHandler(),
});


root.render(
    <StrictMode>
        <ToastProvider>
            <App />
        </ToastProvider>
    </StrictMode>,
)
